import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getActivityFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.activities.code.label',
      contentValue: `{{ ${entity}activity.code }}`,
      description: 'templates.activities.code.description',
    },
    {
      label: 'templates.activities.name.label',
      contentValue: `{{ ${entity}activity.name }}`,
      description: 'templates.activities.name.description',
    },
    {
      label: 'templates.activities.activity_type.label',
      contentValue: `{{ ${entity}activity.activity_type }}`,
      description: 'templates.activities.activity_type.description',
    },
    {
      label: 'templates.activities.min_age.label',
      contentValue: `{{ ${entity}activity.min_age }}`,
      description: 'templates.activities.min_age.description',
    },
    {
      label: 'templates.activities.max_age.label',
      contentValue: `{{ ${entity}activity.max_age }}`,
      description: 'templates.activities.max_age.description',
    },
    {
      label: 'templates.activities.start_date.label',
      contentValue: `{{ ${entity}activity.start_date | date("d/m/Y") }}`,
      description: 'templates.activities.start_date.description',
    },
    {
      label: 'templates.activities.end_date.label',
      contentValue: `{{ ${entity}activity.end_date | date("d/m/Y") }}`,
      description: 'templates.activities.end_date.description',
    },
    {
      label: 'templates.activities.all_disciplines_names_separated_by_coma.label',
      contentValue: `{{ ${entity}activity.all_disciplines_names_separated_by_coma }}`,
      description: 'templates.activities.all_disciplines_names_separated_by_coma.description',
    },
    // {
    //   label: 'templates.activities.publish_start_date_time.label',
    //   contentValue: `{{ ${entity}activity.publish_start_date_time }}`,
    //   description: 'templates.activities.publish_start_date_time.description',
    // },
    // {
    //   label: 'templates.activities.publish_end_date_time.label',
    //   contentValue: `{{ ${entity}activity.publish_end_date_time }}`,
    //   description: 'templates.activities.publish_end_date_time.description',
    // },
    // {
    //   label: 'templates.activities.status.label',
    //   contentValue: `{{ ${entity}activity.status }}`,
    //   description: 'templates.activities.status.description',
    // },
  ];
};

export const templateActivity: EntityTemplateVariables = {
  fields: getActivityFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
